import * as Yup from "yup";
import { type AccountTypeEnum } from "../../graphql/supergraphTypes";
import { createIndividualProfileSchema } from "./schemas";

export interface AddressFormValues {
  streetLine1: string;
  streetLine2?: string;
  city: string;
  state: string;
  province?: string;
  zip?: string;
  country: string;
}

export interface IndividualProfileFormValues extends AddressFormValues {
  firstName: string;
  middleName?: string;
  lastName: string;
  dateOfBirth: Date | null;
  identificationNumber: string;
  accountType?: AccountTypeEnum;
}

export type IndividualProfile = Yup.InferType<ReturnType<typeof createIndividualProfileSchema>>;

export const defaultInitialValues = {
  firstName: "",
  middleName: "",
  lastName: "",
  dateOfBirth: "",
  identificationNumber: "",
  accountType: undefined,
  streetLine1: "",
  streetLine2: "",
  city: "",
  state: "",
  province: "",
  zip: "",
  country: "",
};

export interface IndividualFormProps {
  isUpdating: boolean;
  /**
   * Callback function that is called when the continue button is clicked.
   */
  onContinue: (individualProfile: IndividualProfile) => Promise<void>;

  /**
   * Callback function that is called when the back button is clicked.
   */
  onBack: () => void;

  /**
   * The initial data for the form.
   */
  initialValues: IndividualProfileFormValues;

  /**
   * Profile name to display in the header (e.g., "Jane Parkway")
   */
  profileName?: string;

  /**
   * Whether to show the account type dropdown
   * Should be false for child profiles of joint accounts
   */
  showAccountTypeDropdown?: boolean;
}
